import { useCallback, useState } from "react";
import { Building2, Users, Inbox, Siren, Hourglass, Gauge } from "lucide-react";
import { PageHeader, Card } from "../../components/common";
import { ClientCenter } from "../../components/client/ClientCenter";

export default function AdminOverview() {
  const [s, setS] = useState(null);
  const onSummary = useCallback((x) => setS(x), []);
  const strip = s ? [[Building2, "Empresas ativas", s.empresas_ativas, ""], [Users, "Funcionários administrados", s.funcionarios, ""], [Inbox, "Novas interações", s.interacoes, s.interacoes ? "text-rose-600" : ""],
    [Siren, "Demandas críticas", s.criticas, s.criticas ? "text-rose-700" : ""], [Hourglass, "Aguardando cliente", s.aguardando, ""], [Gauge, "SLA em risco", s.sla_risco, s.sla_risco ? "text-amber-600" : ""]] : [];
  return (
    <div className="space-y-10">
      <PageHeader eyebrow="Administração master" title="Central de clientes" subtitle="Quais clientes precisam da nossa atenção hoje? Cada card é a casa do cliente dentro da DPdigi." />
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3" data-testid="master-summary">
        {strip.map(([I, l, v, cls], i) => <Card key={l} className="p-4" testid={`master-summary-${i}`}><div className="label-xs flex items-center gap-1.5"><I className="h-3.5 w-3.5" />{l}</div><div className={`font-display text-2xl font-semibold mt-1.5 ${cls}`}>{v}</div></Card>)}
      </div>
      <ClientCenter onSummary={onSummary} />
    </div>
  );
}
